import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-deny-dialog',
  templateUrl: './deny-dialog.component.html',
  styleUrls: ['./deny-dialog.component.scss']
})
export class DenyDialogComponent implements OnInit {
  reason: string;

  constructor(public dialogRef: MatDialogRef<DenyDialogComponent>) {}
  ngOnInit(): void {}

  close() {
    this.dialogRef.close([false]);
  }

  cancel() {
    this.dialogRef.close([true, this.reason]);
  }
}
